import React from "react";
import { observer, useLocalStore } from "mobx-react";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { Button, Grid } from "@mui/material";
import { Event } from "@mui/icons-material";
import "react-datepicker/dist/react-datepicker.css";

const useStyle = makeStyles((theme) => ({
  dateButton: {
    backgroundColor: "#f5f5f5",
    borderRadius: "0px",
    border: "none",
    borderTopRightRadius: "4px",
    borderTopLeftRadius: "4px",
    borderBottom: "solid 1px",
    borderColor: theme.palette.primary.main,
    "&:hover": {
      background: "#ccca",
      borderColor: theme.palette.secondary.main,
    },
  },
  noValue: { backgroundColor: "#fff" },
}));
const MyDatePicker = ({
  title,
  value,
  children,
  required = false,
  viewframe = true,
  viewonly = false,
  updatefunc,
  format = "YYYY-MM-DD",
  end = null,
  start = null,
}) => {
  const lstore = useLocalStore(() => ({
    isOpen: false,
  }));
  const classes = useStyle();
  const onChange = (date) => {
    updatefunc(date);
    toggleCalendar();
  };

  const toggleCalendar = (e) => {
    e && e.preventDefault();
    lstore.isOpen = !lstore.isOpen;
  };

  if (viewonly) {
    if (viewframe) {
      return (
        <Grid container direction="column">
          <Grid item>
            <label>
              {title}
              {required && " *"}
            </label>
          </Grid>
          <Grid container item alignItems="center" xs={12}>
            <Grid item xs="auto">
              {value !== null ? moment(value).format(format) : ""}
            </Grid>
            <Grid item xs>
              {children}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container>
          <Grid item xs="auto">
            {value !== null ? moment(value).format(format) : ""}
          </Grid>
          <Grid item xs>
            {children}
          </Grid>
        </Grid>
      );
    }
  } else {
    if (viewframe) {
      return (
        <Grid container direction="column" spacing={0}>
          <Grid item>
            <label>
              {title}
              {required && " *"}
            </label>
          </Grid>
          <Grid container item>
            <Grid item xs="auto">
              <Button
                onClick={toggleCalendar}
                variant="outlined"
                endIcon={<Event />}
                className={
                  value
                    ? classes.dateButton + " " + classes.noValue
                    : classes.dateButton
                }
              >
                {value !== null ? moment(value).format(format) : ""}
              </Button>
              {lstore.isOpen && (
                <DatePicker
                  selected={value}
                  onChange={onChange}
                  withPortal
                  inline
                  showWeekNumbers
                  showYearDropdown
                  showMonthDropdown
                  fixedHeight
                  calendarStartDay={1}
                  maxDate={end}
                  minDate={start}
                />
              )}
            </Grid>
            <Grid item xs>
              {children}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <React.Fragment>
          <Button
            endIcon={<Event />}
            onClick={toggleCalendar}
            variant="outlined"
          >
            {value !== null ? moment(value).format(format) : ""}
          </Button>
          {lstore.isOpen && (
            <DatePicker
              selected={value}
              onChange={onChange}
              withPortal
              inline
              showWeekNumbers
              showYearDropdown
              showMonthDropdown
              fixedHeight
              calendarStartDay={1}
              maxDate={end}
              minDate={start}
            />
          )}
          {children}
        </React.Fragment>
      );
    }
  }
};
export default observer(MyDatePicker);
